module.exports = __webpack_public_path__ + "epilace_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/epilace_3_before_tn.jpg
// module id = 1416
// module chunks = 0